"use client";
import React from "react";
// import UpdatedHeader from "@/components/common/UpdatedHeader";
import QuickContact from "@/components/common/QuickContact";
import BannerMobileHFM from "@/components/pageComponent/hire-from-miles/BannerMobileHFM";
import BrandAndAdvertisingMobileHFM from "@/components/pageComponent/hire-from-miles/BrandAndAdvertisingMobileHFM";
import AccountingTalentPoolMobileHFM from "@/components/pageComponent/hire-from-miles/AccountingTalentPoolMobileHFM";
import LongTermNursingTalentMobileHFM from "@/components/pageComponent/hire-from-miles/LongTermNursingTalentMobileHFM";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";
// import CallNowButton from "@/components/common/callNowButton";

export interface FormProps {
  submitButtonName: string;
  formTitle: string | false;
  showWebinar: boolean;
  popupName?: boolean;
  PopupId?: number;
  popupUserId?: null | number;
}

const MobilePage: React.FC = () => {
  return (
    <main className="flex flex-col items-center bg-white min-h-screen w-full">
      <div className="bg-[#191919] w-full blue_shadow">
        <GlobalHeaderNew />
      </div>
      <BannerMobileHFM />
      <AccountingTalentPoolMobileHFM />
      <LongTermNursingTalentMobileHFM />
      <BrandAndAdvertisingMobileHFM />
      <QuickContact />
      {/* <CallNowButton /> */}
    </main>
  );
};

export default MobilePage;
